import React, { useState } from 'react'
import { Col, Form, Row, Select, Button } from 'antd'
import handleFormError from 'utils/handleFormError'

const { Item } = Form
const { Option } = Select

interface Props {
	onSuccess: () => Promise<void>
	canEditBroadcast: boolean
}

const BroadcastTimeSensitive: React.FC<Props> = ({
	onSuccess,
	canEditBroadcast,
}) => {
	const [loading, setLoading] = useState(false)

	const handleNext = async () => {
		try {
			setLoading(true)
			await onSuccess()
			setLoading(false)
		} catch (error: any) {
			setLoading(false)
			handleFormError(error)
		}
	}

	return (
		<Row>
			<Col xxl={8} xl={12}>
				<p className='custom-label'>Is Time Sensitive?</p>
				<Item
					name='isTimeSensitive'
					trigger='onSelect'
					rules={[
						{
							required: true,
							message: 'Please select a time sensitive',
						},
					]}
				>
					<Select disabled={!canEditBroadcast} loading={loading}>
						<Option value='INSTANT'>Yes (Instant)</Option>
						<Option value='BATCH'>No (Batch Processing)</Option>
					</Select>
				</Item>
				<Button
					hidden={!canEditBroadcast}
					htmlType='button'
					loading={loading}
					onClick={handleNext}
				>
					Next
				</Button>
			</Col>
		</Row>
	)
}

export default BroadcastTimeSensitive
